import type { TranslationDict } from '../types';

export const help: TranslationDict = {
  title: {
    en: 'Help & Feedback',
    'zh-CN': '帮助与反馈',
    ja: 'ヘルプとフィードバック',
  },
  back: {
    en: 'Back',
    'zh-CN': '返回',
    ja: '戻る',
  },
  hero: {
    title: {
      en: 'How can we help?',
      'zh-CN': '我们可以如何帮助你？',
      ja: 'どのようにお手伝いできますか？',
    },
    description: {
      en: 'Find answers, understand our policies, or reach out to us.',
      'zh-CN': '查找答案、了解政策，或直接联系我们。',
      ja: '回答を探す、ポリシーを確認する、または直接お問い合わせください。',
    },
  },
  sections: {
    faq: {
      en: 'Frequently Asked',
      'zh-CN': '常见问题',
      ja: 'よくある質問',
    },
    policies: {
      en: 'Rules & Policies',
      'zh-CN': '规则与政策',
      ja: 'ルールとポリシー',
    },
    contact: {
      en: 'Need more help?',
      'zh-CN': '还需要帮助？',
      ja: 'さらにサポートが必要ですか？',
    },
    feedback: {
      en: 'Send Feedback',
      'zh-CN': '发送反馈',
      ja: 'フィードバックを送る',
    },
  },
  faq: {
    reportContent: {
      en: 'How do I report inappropriate content?',
      'zh-CN': '如何举报不当内容？',
      ja: '不適切なコンテンツはどう通報しますか？',
    },
    suspended: {
      en: 'Why was my account suspended?',
      'zh-CN': '为什么我的账号被封禁？',
      ja: 'なぜアカウントが停止されたのですか？',
    },
    privacy: {
      en: 'How do I protect my privacy?',
      'zh-CN': '如何保护我的隐私？',
      ja: 'プライバシーを守るにはどうすればいいですか？',
    },
    exportData: {
      en: 'How do I request a copy of my data?',
      'zh-CN': '如何申请我的数据副本？',
      ja: '自分のデータのコピーはどう取得しますか？',
    },
  },
  policy: {
    terms: {
      title: {
        en: 'Terms of Service',
        'zh-CN': '服务条款',
        ja: '利用規約',
      },
      description: {
        en: 'Rules and conditions for using Kommend',
        'zh-CN': '使用 Kommend 的规则与条件',
        ja: 'Kommend 利用時のルールと条件',
      },
    },
    privacy: {
      title: {
        en: 'Privacy Policy',
        'zh-CN': '隐私政策',
        ja: 'プライバシーポリシー',
      },
      description: {
        en: 'How we collect, use, and protect your information',
        'zh-CN': '我们如何收集、使用并保护你的信息',
        ja: '情報の収集・利用・保護の方法',
      },
    },
    childSafety: {
      title: {
        en: 'Child Safety Policy',
        'zh-CN': '儿童安全政策',
        ja: '子どもの安全ポリシー',
      },
      description: {
        en: 'Protecting minors from abuse and exploitation',
        'zh-CN': '保护未成年人免受虐待与剥削',
        ja: '未成年者を虐待・搾取から守るための方針',
      },
    },
    suspended: {
      title: {
        en: 'Account Suspension',
        'zh-CN': '账号封禁',
        ja: 'アカウント停止',
      },
      description: {
        en: 'Why accounts get suspended and how to appeal',
        'zh-CN': '账号被封禁的原因与申诉方式',
        ja: '停止理由と異議申し立て方法',
      },
    },
  },
  contact: {
    description: {
      en: "If you can't find your answer above, reach out to our team.",
      'zh-CN': '如果上面没有你的答案，请联系我们的团队。',
      ja: '上記で解決しない場合は、サポートチームにお問い合わせください。',
    },
    generalLabel: {
      en: 'General Support',
      'zh-CN': '常规支持',
      ja: '一般サポート',
    },
    safetyLabel: {
      en: 'Safety Issues',
      'zh-CN': '安全问题',
      ja: '安全に関する問題',
    },
    privacyLabel: {
      en: 'Privacy & Data',
      'zh-CN': '隐私与数据',
      ja: 'プライバシーとデータ',
    },
  },
  feedback: {
    description: {
      en: 'Help us improve Kommend. Share your thoughts, report bugs, or suggest features.',
      'zh-CN': '帮助我们改进 Kommend。欢迎分享想法、反馈问题或提出功能建议。',
      ja: 'Kommend 改善のため、ご意見・不具合報告・機能提案をお寄せください。',
    },
    action: {
      en: 'Send Feedback',
      'zh-CN': '发送反馈',
      ja: 'フィードバックを送信',
    },
  },
  footer: {
    copyright: {
      en: '© {{year}} Kommend. All rights reserved.',
      'zh-CN': '© {{year}} Kommend。保留所有权利。',
      ja: '© {{year}} Kommend. All rights reserved.',
    },
  },
};

